import React from 'react'
import { connect } from 'react-redux'
import interactiveEdge from '../../images/svg/interactiveEdge.svg'
import Grid from '@mui/material/Grid';

class About extends React.Component {

    render() {
        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <div className="abouTop">
                            <img src={interactiveEdge} alt="Interactive EDGE" />
                        </div>
                        <h3 className="subHeadInnerABout">
                            Helping organizations improve
                            {' '}
                            <br />
                            {' '}
                            productivity, enhance
                            efficiency,
                            <br />
                            {' '}
                            and achieve brand consistency
                            <br />
                            {' '}
                            since 1996.
                        </h3>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <div className="topSpace">
                                    <p className="contHeadAbout">Our History</p>
                It started with the development of our cutting-edge multimedia
                marketing software for field sales organizations that wanted to
                leverage laptop computers in their day-to-day selling
                activities. Building on our success, we then added to our
                solutions suite – technology that would aid in the creation of
                data driven marketing collateral for some of the most successful
                new item launches ever – for products such as Colgate Total
                Toothpaste, Listerine Pocket Paks, Children’s Advil, J&J’s
                Bathtime Buddies, and Nestlé Skillet Sensations.
              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <div className="topSpace">
                                    <p className="contHeadAbout">Our Vision</p>
                To be the catalyst in communities of customers, contributors,
                and partners creating better technology the open source way
              </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(null, null)(About)
